import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  PostResendPayload,
  PostResendQuery,
  PostResendResponse,
} from '~/lib/services/api/user'

import {
  useMutation,
} from '@tanstack/react-query'
import {
  postResend,
} from '~/lib/services/api/user'

function useResend() {
  const mutationFn: PostResendQuery = async (newData) => {
    const response = await postResend(newData)
    return response.data
  }

  const options: UseMutationOptions<
    PostResendResponse,
    DefaultError,
    PostResendPayload,
    unknown
  > = {
    mutationFn,
  }

  return useMutation(options)
}

export default useResend
